import {
  financialStatementHttp,
  FinancialStatementHttp,
} from "../services/FinancialStatementHttp";
import {
  OccupationDirectoryHttp,
  occupationDirectoryHttpRepository,
} from "../services/OccupationDirectoryHttp";
import { authService } from "../services/AuthService";
import { HttpConfig } from "../helpers/http.config";

interface Repositories {
  financialStatements: FinancialStatementHttp;
  occupations: OccupationDirectoryHttp;
}

export function makeRepositories(cfg: HttpConfig): Repositories {
  const financialStatements = financialStatementHttp(authService, cfg);
  const occupations = occupationDirectoryHttpRepository(authService, cfg);

  return {
    financialStatements,
    occupations,
  };
}
